import { render, staticRenderFns } from "./SystemMessage.vue?vue&type=template&id=2a90269f&scoped=true&"
import script from "./SystemMessage.vue?vue&type=script&lang=js&"
export * from "./SystemMessage.vue?vue&type=script&lang=js&"
import style0 from "../../style/chat-view.scss?vue&type=style&index=0&id=2a90269f&lang=scss&scoped=true&"
import style1 from "./SystemMessage.vue?vue&type=style&index=1&id=2a90269f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90269f",
  null
  
)

export default component.exports